module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-BlackItalic.e9ce49e.woff2";